export function isDisabled(contract) {
  return (
    contract.signed_date ||
    (contract.signature_request &&
      contract.signature_request?.status !== 'cancelled')
  )
}
